'use client';

import React, { useState } from 'react';

import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

const adminNav = [
  { label: 'Dashboard', href: '/admin-dashboard', icon: 'Squares2X2Icon', badge: null },
  { label: 'Properties', href: '/admin-dashboard', icon: 'HomeIcon', badge: '48.2K' },
  { label: 'Listings Queue', href: '/admin-dashboard', icon: 'ClipboardDocumentListIcon', badge: '24' },
  { label: 'Agents', href: '/admin-dashboard', icon: 'UserGroupIcon', badge: null },
  { label: 'Agencies', href: '/admin-dashboard', icon: 'BuildingOffice2Icon', badge: null },
  { label: 'Developers', href: '/admin-dashboard', icon: 'BuildingOfficeIcon', badge: null },
  { label: 'Communities', href: '/admin-dashboard', icon: 'MapIcon', badge: null },
  { label: 'Users', href: '/admin-dashboard', icon: 'UserIcon', badge: null },
  { label: 'Leads', href: '/admin-dashboard', icon: 'FunnelIcon', badge: '142' },
  { label: 'Viewings', href: '/admin-dashboard', icon: 'CalendarDaysIcon', badge: null },
  { label: 'Verification', href: '/admin-dashboard', icon: 'ShieldCheckIcon', badge: '7' },
  { label: 'Analytics', href: '/admin-dashboard', icon: 'ChartBarIcon', badge: null },
  { label: 'Settings', href: '/admin-dashboard', icon: 'CogIcon', badge: null },
];

export default function AdminSidebar() {
  const [active, setActive] = useState('Dashboard');

  return (
    <aside className="w-64 flex-shrink-0 bg-card border-r border-border min-h-screen sticky top-20 flex flex-col">
      <div className="p-5 border-b border-border">
        <div className="flex items-center gap-2">
          <AppLogo size={28} />
          <div>
            <div className="font-extrabold text-primary text-sm">OROW Admin</div>
            <div className="text-xs text-muted-foreground">Platform Management</div>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-3 space-y-0.5 overflow-y-auto">
        {adminNav.map((item) => (
          <button
            key={`admin-nav-${item.label}`}
            onClick={() => setActive(item.label)}
            className={`w-full flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${
              active === item.label
                ? 'bg-primary/10 text-primary font-semibold' :'text-foreground/70 hover:bg-muted hover:text-foreground'
            }`}
          >
            <div className="flex items-center gap-2.5">
              <Icon name={item.icon as 'HomeIcon'} size={17} />
              {item.label}
            </div>
            {item.badge && (
              <span className={`text-xs font-bold px-1.5 py-0.5 rounded-full ${
                active === item.label ? 'bg-primary text-white' : 'bg-muted text-muted-foreground'
              }`}>
                {item.badge}
              </span>
            )}
          </button>
        ))}
      </nav>

      <div className="p-4 border-t border-border">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-xl bg-primary/20 flex items-center justify-center">
            <Icon name="UserIcon" size={16} className="text-primary" />
          </div>
          <div>
            <div className="text-xs font-bold text-foreground">Super Admin</div>
            <div className="text-xs text-muted-foreground">admin@orow.ae</div>
          </div>
        </div>
      </div>
    </aside>
  );
}